import { Link } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { Card, CardContent } from '@/components/ui/card'
import { FileImage, Sparkles } from 'lucide-react'

export function PublicGifPage() {
  return (
    <div className="min-h-screen bg-background">
      <header className="border-b sticky top-0 bg-background/95 backdrop-blur z-10">
        <div className="container mx-auto flex items-center justify-between px-4 py-3 max-w-5xl">
          <Link to="/" className="flex items-center gap-2 font-semibold">
            <FileImage className="h-5 w-5 text-primary" />
            FrameX
          </Link>
          <Button asChild size="sm">
            <Link to="/?view=studio">
              <Sparkles className="h-4 w-4 mr-2" />
              Open Studio
            </Link>
          </Button>
        </div>
      </header>

      <main className="container mx-auto px-4 py-16 max-w-2xl">
        <Card>
          <CardContent className="py-12 text-center space-y-4">
            <FileImage className="h-14 w-14 mx-auto text-muted-foreground" />
            <div>
              <h1 className="text-2xl font-bold">Shared GIFs are not available</h1>
              <p className="text-muted-foreground mt-2">
                FrameX now runs as a static, local-first app. GIFs are created and downloaded in your browser instead of being hosted on a server.
              </p>
            </div>
            <Button asChild>
              <Link to="/?view=gif">Create a GIF</Link>
            </Button>
          </CardContent>
        </Card>
      </main>
    </div>
  )
}

export default PublicGifPage